<script setup>
/* Props */
const props = defineProps({
  content: {
    type: String,
    default: '',
  },
});
</script>

<template>
  <g-copy
    id="js__product__legal-text"
    class="app__product__legal-text"
    type="small"
    v-html="props.content"
  />
</template>

<style lang="scss">
.app__product__legal-text {
  font-size: 0.688rem; // 11px
}
</style>
